const en = require('../../packages/chronos-ruo-static-content/translations/en.json')

export function translate(key) {
    if (Object.keys(en).includes(key)) {
        return en[key]
    }
    return key
}